import {useUserContext} from '@containers/App/UserProvider'
import {FeatureFlags} from '@shared/constants/featureFlags'
import {useNavigationExperience} from '@shared/utils/navigationExperience'

/**
 * Whether the user may use the new experience: the `ui_v2_experience` flag (AB#6639).
 * Null-safe on purpose: components outside the app shell (tests, isolated
 * dialogs) have no user context, and it simply stays off there.
 */
export const useHasV2App = (): boolean =>
  Boolean(useUserContext()?.featureFlags?.has(FeatureFlags.UI_V2_EXPERIENCE))

/** Whether the user sees the new experience: flagged, and not switched back to classic. */
export const useV2App = (): boolean => {
  const flagged = useHasV2App()
  const experience = useNavigationExperience()
  return flagged && experience === 'new'
}
